import Axios from 'axios'

let url 
if (!window.location.href.includes('localhost')) {
    url = process.env.REACT_APP_API_URL
} else {
    url = 'http://localhost:8080/api'
}

const axios = Axios.create({
    baseURL: url,
    headers: {
        "x-auth": localStorage.getItem('token')
    }
})

axios.interceptors.request.use(config => {
    config.headers['x-auth'] = localStorage.getItem('token')
    return config
})


export default axios